export enum FieldNames {
  DamageLocation = 'damageLocation',
  LicensePlate = 'licensePlate',
  Involved = 'involved',
  DamageSide = 'damageSide',
  DamageClassification = 'damageClassification',
  VehicleCoordinates = 'vehicleCoordinates',
  FormPhoto = 'formPhoto',
  PhotosOwn = 'photosOwn',
  PhotosOther = 'photosOther',
  PhotosObject = 'photosObject',
  PhotosEnvironment = 'photosEnvironment',
  WhatHappened = 'whatHappened',
}

export default FieldNames
